import { render } from "./AllAppointment.vue?vue&type=template&id=443dda57&scoped=true"
import script from "./AllAppointment.vue?vue&type=script&lang=js"
export * from "./AllAppointment.vue?vue&type=script&lang=js"

import "./AllAppointment.vue?vue&type=style&index=0&id=443dda57&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443dda57"]])

export default __exports__